import type { SetupState } from '@tandemone/types'
import { createContext } from 'react'

export type SetupContextType = {
  setupState: SetupState | null
}

export const SetupContext = createContext<SetupContextType | null>(null)
